import _ from 'lodash';
import { Member } from './Member';
import { Model } from './Model';

export class Membership extends Model {

  /**
   * @property id
   *
   * The ID of this membership.
   *
   * @type {string}
   */

  /**
   * @property name
   *
   * The name of this membership.
   *
   * @type {string}
   */

  /**
   * @property memberSince
   *
   * The date the membership started.
   *
   * @type {Date}
   */

  /**
   * @property members
   *
   * The member records for the members of this membership.
   *
   * @type {string[]}
   */

  constructor( options={} ) {
    if ( _.isString( options ) ) options = { id : options };
    const { members=[], ...opts } = options;
    super( opts, {
      members : _.map( members, member => ( new Member( member ) ) ),
    } );
  }

  getMember( id ) {
    return _.find( this.members, { id } );
  }

}
